/* Contact measurement uses the store's existing Google tag. No new tracker is loaded. */
(() => {
  'use strict';
  if (window.__yvicorContactAnalytics) return;
  window.__yvicorContactAnalytics = true;

  const script = document.currentScript;
  const measurementId = script?.dataset.measurementId;
  if (!/^G-[A-Z0-9]+$/.test(measurementId || '')) return;
  const businessServices = new Set(['patronaje', 'prototipo', 'microcoleccion', 'uniformes', 'controlcalidad']);
  const services = new Set([...businessServices, 'encargo', 'producto', 'otro']);
  const contexts = new Set(['marca', 'general']);
  const contactHandles = new Set(['contact', 'contacte', 'kontakt', 'contact-us', 'contact-fr', 'contatto', 'contacto-pt']);
  const attemptKey = 'yvicor.contact.pending.v1';
  const originKey = 'yvicor.contact.origin.v1';
  const queue = [];
  const startedForms = new WeakMap();
  const handledSuccesses = new WeakSet();
  let retryTimer;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const safePath = value => {
    try { return new URL(value, location.origin).pathname.slice(0, 300); } catch { return ''; }
  };
  const service = form => {
    const value = form?.querySelector('[data-yvicor-contact-service]')?.value;
    return services.has(value) ? value : 'otro';
  };
  const context = form => businessServices.has(service(form)) || form?.querySelector('[data-yvicor-contact-origin]')?.value === 'marca' ? 'marca' : 'general';
  const formState = form => ({ service: service(form), context: context(form) });
  function isContactPage(url) {
    const parts = url.pathname.replace(/\/$/, '').split('/');
    return url.origin === location.origin && parts.at(-2) === 'pages' && contactHandles.has(parts.at(-1));
  }
  function store(key, value) {
    if (!allowed()) return;
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* Storage may be unavailable. */ }
  }
  function read(key) {
    if (!allowed()) return null;
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
  }
  function remove(key) {
    try { sessionStorage.removeItem(key); } catch { /* Storage may be unavailable. */ }
  }
  function pageContext() {
    const template = document.querySelector('#MainContent')?.dataset.template?.split('.')[0];
    const pageType = ['article', 'blog', 'page', 'product', 'collection', 'index', 'search', 'cart'].includes(template) ? template : 'other';
    return {
      send_to: measurementId,
      page_location: location.origin + safePath(location.href),
      page_referrer: document.referrer ? (() => { try { const url = new URL(document.referrer); return url.origin + url.pathname; } catch { return ''; } })() : '',
      page_type: pageType,
      content_language: (document.documentElement.lang || 'es').toLowerCase().slice(0, 10)
    };
  }
  function flush() {
    clearTimeout(retryTimer);
    if (!allowed()) { queue.length = 0; return; }
    while (queue.length && typeof window.gtag === 'function') {
      const item = queue.shift();
      if (Date.now() - item.at > 10000) continue;
      try { window.gtag('event', item.name, item.params); } catch { /* Measurement must never block contact. */ }
    }
    while (queue.length && Date.now() - queue[0].at > 10000) queue.shift();
    if (queue.length) retryTimer = setTimeout(flush, 250);
  }
  function emit(name, params) {
    if (!allowed()) return;
    queue.push({ name, params: { ...pageContext(), ...params }, at: Date.now() });
    if (queue.length > 20) queue.shift();
    flush();
  }
  function contactMethod(link) {
    try {
      const url = new URL(link.href, location.href);
      if (url.protocol === 'mailto:') return 'email';
      if (url.protocol === 'tel:') return 'phone';
      if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) return 'whatsapp';
      // Generic in-page navigation is not a contact action. An explicit form CTA remains measurable.
      if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash && !link.matches('.ay-contact-btn-form')) return null;
      if (isContactPage(url)) return 'form';
      if (url.origin === location.origin && link.matches('.ay-contact-btn-form')) return 'form';
    } catch { /* Ignore non-navigation links. */ }
    return null;
  }
  function placement(link) {
    if (link.matches('.whatsapp-float')) return 'floating';
    if (link.closest('#header-group, header-component')) return 'header';
    if (link.closest('footer')) return 'footer';
    if (link.closest('.ay-contact-block')) return 'content_cta';
    return 'content';
  }
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !allowed()) return;
    const method = contactMethod(link);
    if (!method) return;
    if (method === 'form' && !isContactPage(new URL(location.href))) store(originKey, { path: safePath(location.href), at: Date.now() });
    emit('contact_click', { contact_method: method, contact_placement: placement(link) });
  });

  function nativeForm(target) {
    const form = target instanceof Element ? target.closest('form') : null;
    return form?.closest('[data-yvicor-contact-form]') ? form : null;
  }
  document.addEventListener('focusin', event => {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches('input, select, textarea') || target.matches(':disabled') || target.readOnly || ['hidden', 'submit', 'reset', 'button', 'image'].includes(target.type) || target.closest('[data-yvicor-contact-success], [data-yvicor-contact-error]')) return;
    const form = nativeForm(event.target);
    if (!form || startedForms.has(form) || !allowed()) return;
    const initial = formState(form);
    startedForms.set(form, initial);
    emit('contact_form_start', { contact_method: 'form', contact_service: initial.service, contact_context: initial.context, contact_service_initial: initial.service, contact_context_initial: initial.context });
  });
  document.addEventListener('submit', event => {
    const form = nativeForm(event.target);
    if (!form || event.defaultPrevented || !form.checkValidity() || !allowed()) return;
    const origin = read(originKey);
    // Initial means first relevant focus; a submission without that focus uses its current state.
    const initial = startedForms.get(form) || formState(form);
    store(attemptKey, {
      at: Date.now(),
      service: service(form),
      context: context(form),
      initialService: initial.service,
      initialContext: initial.context,
      source: origin && Date.now() - origin.at < 1800000 ? safePath(origin.path) : safePath(location.href)
    });
  });
  function checkSuccess() {
    const marker = document.querySelector('[data-yvicor-contact-success]');
    if (!marker || handledSuccesses.has(marker) || !allowed()) return;
    const pending = read(attemptKey);
    if (!pending || !Number.isFinite(pending.at) || Date.now() - pending.at > 1800000 || !services.has(pending.service)) return;
    handledSuccesses.add(marker);
    remove(attemptKey);
    remove(originKey);
    const finalContext = contexts.has(pending.context) ? pending.context : (businessServices.has(pending.service) ? 'marca' : 'general');
    emit('generate_lead', {
      contact_method: 'form', contact_service: pending.service, contact_context: finalContext,
      contact_service_final: pending.service, contact_context_final: finalContext,
      // A pending attempt from the previous asset version has no known initial state.
      ...(services.has(pending.initialService) ? { contact_service_initial: pending.initialService } : {}),
      ...(contexts.has(pending.initialContext) ? { contact_context_initial: pending.initialContext } : {}),
      source_path: safePath(pending.source)
    });
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { queue.length = 0; clearTimeout(retryTimer); remove(attemptKey); remove(originKey); }
    else { flush(); checkSuccess(); }
  });
  window.addEventListener('pageshow', checkSuccess);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkSuccess, { once: true });
  else checkSuccess();
})();
